export class EmailRecipient {
  // description: Class used to contain To, CC and BCC recipients of an email
  public email: string; // ($email)The required e-mail address
  public isFreeContact?: boolean; // Indicates whether the contact is free and it's not already added to users list of the mail. If true, a new user will be added to mail.

  // public displayName?: string; // The display name, null when not available
  // public type?: string; // The EmailRecipientType(To, CC, BCC, Resource, Room)
  // public addressType?: string; // The addresstype, null when not available
}
